import React, { useState, useEffect } from 'react';
import DashboardLayout from '../Dashboard/layout'; // Path to your layout
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import './ViewSocialLinks.css';
import { ADDBTN, Headings, SerchInput, UserSelect } from '../RegisteredUsersList/ViewRegList';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { FiEdit } from 'react-icons/fi';

const ViewSocialLinks = () => {
  const [socialLinks, setSocialLinks] = useState([]);
  const [filteredLinks, setFilteredLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [linksPerPage] = useState(5); // Number of links per page
  const navigate = useNavigate();
  const [selectedStatus, setSelectedStatus] = useState('');

  // Fetch social links
  
    const fetchSocialLinks = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/admin/social-links`);
        if (response.data && response.data.socialLinks.length > 0) {
          setSocialLinks(response.data.socialLinks);
          setFilteredLinks(response.data.socialLinks);
        } else {
          //Swal.fire('No Data Available', 'There are no social links available at the moment.', 'info');
        }
      } catch (error) {
        console.error('Failed to fetch social links:', error);
        Swal.fire('Error', 'Failed to load social links. Please try again later.', 'error');
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchSocialLinks();
    }, []);

  // Filter social links based on search query
  useEffect(() => {
    let filtered = socialLinks;
 // console.log('helloo',filtered);
  
    if (selectedStatus) {
      filtered = filtered.filter((socialLink) => socialLink.accountStatus === parseInt(selectedStatus));
    }

    if (searchQuery) {
      filtered = filtered.filter((link) =>
        link.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredLinks(filtered);
    setCurrentPage(1);
    
  }, [selectedStatus, searchQuery, socialLinks]);

  // Handle deleting a social link
  const handleDeleteLink = (linkId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this social link!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_BASE_URL}api/admin/social-links/${linkId}`)
          .then(() => {
            Swal.fire('Deleted!', 'The social link has been deleted.', 'success');
            fetchSocialLinks(); // This now works!
          })
          .catch((error) => {
            console.error('Error deleting social link:', error);
            Swal.fire('Error', 'There was an issue deleting this social link.', 'error');
          });
      }
    });
  };

  // Handle editing a social link
  const handleEditLink = (linkId) => {
    navigate(`/edit-social-link/${linkId}`);
  };

  // Pagination
  const indexOfFirstLink =(currentPage - 1)  * linksPerPage;
  const currentLinks = filteredLinks.slice(indexOfFirstLink, indexOfFirstLink +linksPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredLinks.length / linksPerPage);

  

  const statusOptions = [
    { value: '', label: 'All' },
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
  ];

  return (
    <DashboardLayout>
      <section className="MainDivSec">
        <Headings headspan="Social Links" hedtext=" List" />

        <div className="TopSelctDiv">
          <div className="LeftSlct">
            <UserSelect slctvluename="Filter by Status:" selectedRole={selectedStatus} slctonchange={(e) => setSelectedStatus(e.target.value)} options={statusOptions} slcthtmlfor="statusFilter" />
          </div>
          <div className="RytSrch">
            <SerchInput
              searchvalue={searchQuery}
              searchonchange={(e) => setSearchQuery(e.target.value)}
              srchid="searchQuery"
              srchplcehldr="Search by name"
            />
            <ADDBTN adtext="Add Social Link" adonclick={() => navigate('/add-social-link')} />
          </div>
        </div>

        <div className="TableSec">
          {loading ? (
            <p className="Loadingpara">Loading...</p>
          ) : (
            <>
              <div className="UserTableDiv">
                <table className="User_Table">
                  <thead>
                    <tr>
                      <th>SR NO</th>
                      <th>Image</th> {/* Image Column */}
                      <th>Name</th>
                      <th>Links</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentLinks.length > 0 ? (
                    currentLinks.map((link, index) => (
                      <tr key={link.id}>
                         <td>{indexOfFirstLink + index + 1}</td> {/* Updated SR NO */}
                        <td>
                          {/* Displaying Image if it exists */}
                          {link.image ? (
                            <img src={link.image} alt={link.name} className="link-image" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                          ) : (
                            <span>No Image</span>
                          )}
                        </td>
                        <td>{link.name}</td>
                        <td>{link.url}</td>
                        <td>{link.accountStatus === 1 ? 'Active' : 'Inactive'}</td>
                        <td className="EditDelteDiv">
                          <button onClick={() => handleEditLink(link._id)}>
                            <FiEdit />
                          </button>
                          <button
                            className="delete-btn"
                            onClick={() => handleDeleteLink(link._id)}
                          >
                            <MdDelete />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                  <tr>
                    <td colSpan="6">Social Links not found.</td>
                  </tr>
                )}
                  </tbody>
                </table>
              </div>
              {filteredLinks.length > 0 && (
              <div className="Tablepagination">
                <button
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <FaAngleDoubleLeft />
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => paginate(index + 1)}
                    className={currentPage === index + 1 ? 'active' : ''}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <FaAngleDoubleRight />
                </button>
              </div>
              )}
            </>
          )}
        </div>
      </section>
    </DashboardLayout>
  );
};

export default ViewSocialLinks;

